import { debounce } from "../../../util/delay-debounce-throttle.js";
export class TileLayer {
    tileDimensions;
    zoom;
    resolution;
    tileFactory;
    //this is what the google interface expects
    alt;
    maxZoom;
    minZoom;
    name;
    projection;
    radius;
    tileSize;
    map;
    //google maps adds initially all the tiles twice and then removes one set again
    //We need to do some bookkeeping in order to cope with this quirk. 
    //-only actually construct and add when the tile was not present and set the counter per tile on 1
    //-increase the counter when a tile at the same coordinate is requested again. Return the existing tile element
    //-decrease the counter when the tile is being released
    //-only actually remove the tile when the counter reaches 0
    tileKeys = new Map();
    //assume all tiles ready when no more tiles are added after ??200ms 
    tileAdded = debounce(() => {
        this.tileFactory.onReady(this.zoom, this.resolution, this.tileDimensions);
    }, 200);
    constructor() {
        //we use
        this.tileDimensions = { x: 256, y: 256 };
        this.zoom = 0;
        this.resolution = { x: this.tileDimensions.x, y: this.tileDimensions.y };
        //google expects this parameter to be around
        this.tileSize = new google.maps.Size(this.tileDimensions.x, this.tileDimensions.y);
    }
    getTileDimensions() {
        return this.tileDimensions;
    }
    getZoom() {
        return this.zoom;
    }
    getResolution() {
        return this.resolution;
    }
    //needed for implementing the google.maps.MapType interface
    getTile(coord, zoom, ownerDocument) {
        if (coord && ownerDocument) {
            const coords = { x: coord.x, y: coord.y, z: zoom };
            if (this.zoom !== coords.z) {
                this.zoom = coords.z;
                this.resolution = {
                    x: Math.pow(2, coords.z) * this.tileDimensions.x,
                    y: Math.pow(2, coords.z) * this.tileDimensions.y,
                };
            }
            const key = `${coords.x}_${coords.y}_${coords.z}`;
            let tile = this.tileKeys.get(key);
            if (tile === undefined) {
                const tileElem = this.tileFactory.createTile(coords, ownerDocument);
                this.tileKeys.set(key, { count: 1, elem: tileElem });
                //console.log(`getTile ${key} called`);
                this.tileAdded();
                return tileElem;
            }
            else {
                //console.log(`tile already added`);
                tile.count++;
                return tile.elem;
            }
        }
        else {
            return null;
        }
    }
    //needed for implementing the google.maps.MapType interface
    releaseTile(tileElem) {
        if (tileElem && tileElem.dataset) {
            const key = tileElem.dataset["key"];
            if (key) {
                let tile = this.tileKeys.get(key);
                if (tile === undefined) {
                    //console.log(`releaseTile ${key} called for unknown tile`);
                    this.tileFactory.removeTile(key);
                }
                else {
                    tile.count--;
                    if (tile.count === 0) {
                        //console.log(`releaseTile ${key} called`);
                        this.tileKeys.delete(key);
                        this.tileFactory.removeTile(key);
                    }
                    else {
                        //console.log(`releaseTile ${key} blocked`);
                    }
                }
            }
        }
    }
    /**
     * Call this method when it has to be removed and or needs to be destroyed
     */
    remove() {
        //breakdown
        if (this.map) {
            for (let i = 0; i < this.map.overlayMapTypes.getLength(); i++) {
                if (this.map.overlayMapTypes.getAt(i) === this) {
                    this.map.overlayMapTypes.removeAt(i);
                    i--;
                }
            }
            this.map = undefined;
        }
    }
    /**
     * Call this method in order to add this layer to the given map.
     * @param map The leaflet map where to add this layer to.
     */
    addTo(map, tileFactory) {
        if (map) {
            this.map = map;
            this.tileFactory = tileFactory;
            this.map.overlayMapTypes.insertAt(0, this);
        }
    }
}
